"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Info(props) {
  var size = props.size,
      rest = _objectWithoutProperties(props, ["size"]);

  return _react.default.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    fill: "none"
  }, rest), _react.default.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#195985"
  }), _react.default.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 11.2,
    fill: "#2578B2"
  }), _react.default.createElement("path", {
    d: "M16.278 18.301l-.153.627c-.52.205-2.317 1.063-3.354.15a1.317 1.317 0 01-.464-1.035c0-.783.258-1.466.721-3.106.082-.31.182-.712.182-1.031 0-.55-.209-.697-.775-.697-.277 0-.583.099-.86.202l.154-.627c.617-.25 1.393-.557 2.057-.557.997 0 1.73.497 1.73 1.442 0 .273-.048.75-.147 1.08l-.573 2.027c-.118.41-.333 1.313 0 1.58.327.265 1.1.125 1.482-.055zM15.25 11a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: "#fff"
  }));
}

Info.propTypes = {
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Info.defaultProps = {
  size: '24'
};

var _default = _react.default.memo(Info);

exports.default = _default;